const { fetchLegalData: fetchLegalDataApi } = require('../api/legal');
const { legalApp } = require('../reducers/legalApp');
const { fetchConfigurationIfNeeded } = require('./ConfigurationActions');

function fetchLegalDataApp({ versionCode } = {}) {
  return (dispatch, getState) => {
    const {
      auth: { apiUrl },
    } = getState();

    if (!apiUrl) {
      return Promise.resolve();
    }

    const fetchPromise = (async () => {
      try {
        const config =
          !versionCode && (await dispatch(fetchConfigurationIfNeeded()));
        const data = await fetchLegalDataApi(apiUrl, {
          platform: 'app',
          versionCode: versionCode || config?.latestAppVersionCode,
        });
        dispatch(legalApp.fetchSuccessful({ versionCode, data }));
        return data;
      } catch (e) {
        dispatch(legalApp.fetchFailed(e));
        throw e;
      }
    })();

    dispatch(legalApp.fetchInProgress(fetchPromise));

    return fetchPromise;
  };
}

function fetchLegalDataAppIfNeeded({ versionCode } = {}) {
  return async (dispatch, getState) => {
    const {
      legalApp: { fetchPromise, data, versionCode: v, ...state },
    } = getState();

    if (legalApp.shouldFetch(state) || versionCode !== v) {
      return dispatch(fetchLegalDataApp({ versionCode }));
    }

    return typeof fetchPromise?.then === 'function' ? fetchPromise : data;
  };
}

module.exports = {
  fetchLegalDataApp,
  fetchLegalDataAppIfNeeded,
};
